import type {
  AdminTicketDetailedListItemDto,
  AdminTicketDetailsDto,
  DicoStatusDto,
  DicoTicketStateDto,
  HomeDnaStatusDto,
  HomeDnaTicketStateDto,
  PortfolioAdminTicketDto,
  RemsStatusDto,
  RemsTicketStateDto,
  TicketIntegrationStatusSummaryDto,
  WunderbricksStatusDto,
  WunderbricksTicketStateDto,
} from "@/api/types";

type TicketDto = AdminTicketDetailsDto | AdminTicketDetailedListItemDto | PortfolioAdminTicketDto;

function getIntegrationData<T>(integration?: TicketIntegrationStatusSummaryDto): Partial<T> | undefined {
  if (integration?.data && typeof integration.data === "object" && !Array.isArray(integration.data)) {
    return integration.data as Partial<T>;
  }
}

export function getRemsStatus(ticket: TicketDto): RemsStatusDto | undefined {
  const integration = ticket.integrations?.rems;
  if (!integration || (!integration.enabled && !integration.present)) {
    return;
  }

  const data = getIntegrationData<RemsStatusDto>(integration);

  return {
    ...data,
    state: integration.state as RemsTicketStateDto,
    errorDetails: integration.errorDetails ?? data?.errorDetails,
    externalId: integration.externalId ?? data?.externalId,
    version: data?.version ?? "v2",
    contracts: data?.contracts ?? [],
  };
}

export function getHomeDnaStatus(ticket: TicketDto): HomeDnaStatusDto | undefined {
  const integration = ticket.integrations?.homeDna;
  if (!integration || (!integration.enabled && !integration.present)) {
    return;
  }

  const data = getIntegrationData<HomeDnaStatusDto>(integration);

  return {
    ...data,
    state: integration.state as HomeDnaTicketStateDto,
    errorDetails: integration.errorDetails ?? data?.errorDetails,
  };
}

export function getDicoStatus(ticket: TicketDto): DicoStatusDto | undefined {
  const integration = ticket.integrations?.dico;
  if (!integration || (!integration.enabled && !integration.present)) {
    return;
  }

  const data = getIntegrationData<DicoStatusDto>(integration);

  return {
    ...data,
    state: integration.state as DicoTicketStateDto,
    errorDetails: integration.errorDetails ?? data?.errorDetails,
  };
}

export function getWunderbricksStatus(ticket: TicketDto): WunderbricksStatusDto | undefined {
  const integration = ticket.integrations?.wunderbricks;
  if (!integration || (!integration.enabled && !integration.present)) {
    return;
  }

  const data = getIntegrationData<WunderbricksStatusDto>(integration);

  return {
    ...data,
    state: integration.state as WunderbricksTicketStateDto,
    caseId: data?.caseId ?? integration.externalId,
    errorDetails: integration.errorDetails ?? data?.errorDetails,
    isClosed: data?.isClosed ?? false,
    canSubmit: data?.canSubmit ?? false,
  };
}
